document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('.section--animated');
    // Check if IntersectionObserver is Supported
    if ('IntersectionObserver' in window) {
        // If so, continue with the scroll logic
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(e => {
                    if (e.intersectionRatio > 0) {
                        e.target.classList.add('section--in-view');
                        observer.unobserve(e.target);
                    }
                });
            },
            {rootMargin: "0px 0px -" + (window.innerHeight * .25) + "px 0px"}
        );
        sections.forEach ( v => {
            observer.observe(v);
        });
        document.querySelectorAll('.section--animated-autoplay').forEach(v => v.classList.add('section--in-view'));
    } else {
        // If not, then add the animation classes to the sections.
        sections.forEach(v => {
            v.classList.add('section--in-view');
        });
    }
});